import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="container-fluid">
    </div>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// src/pages/Main/Footer.js